import { useMemo } from "react";
import { useStoreSettings } from "@/hooks/useStoreSettings";

export interface LegalData {
  razaoSocial: string;
  nomeFantasia: string;
  cnpj: string;
  inscricaoEstadual: string;
  telefone: string;
  email: string;
  cep: string;
  rua: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  enderecoCompleto: string;
  hasLegalData: boolean;
}

export function useLegalData(): LegalData {
  const { settings } = useStoreSettings();
  const sd = settings.settings_data;

  return useMemo(() => {
    const razaoSocial = (sd.legal_razao_social as string) || "";
    const nomeFantasia = (sd.legal_nome_fantasia as string) || "";
    const cnpj = (sd.legal_cnpj as string) || "";
    const inscricaoEstadual = (sd.legal_inscricao_estadual as string) || "";
    const telefone = (sd.legal_telefone as string) || settings.phone || "";
    const email = (sd.legal_email as string) || "";
    const cep = (sd.legal_cep as string) || "";
    const rua = (sd.legal_rua as string) || "";
    const numero = (sd.legal_numero as string) || "";
    const complemento = (sd.legal_complemento as string) || "";
    const bairro = (sd.legal_bairro as string) || "";
    const cidade = (sd.legal_cidade as string) || "";
    const estado = (sd.legal_estado as string) || "";

    const parts = [rua, numero, complemento, bairro, cidade, estado, cep].filter(Boolean);
    const enderecoCompleto = parts.length >= 3 ? parts.join(", ") : "";

    const hasLegalData = !!(razaoSocial || cnpj);

    return {
      razaoSocial,
      nomeFantasia,
      cnpj,
      inscricaoEstadual,
      telefone,
      email,
      cep,
      rua,
      numero,
      complemento,
      bairro,
      cidade,
      estado,
      enderecoCompleto,
      hasLegalData,
    };
  }, [sd, settings.phone]);
}
